import { render } from "./DbsButton.vue?vue&type=template&id=b31dc2aa"
import script from "./DbsButton.vue?vue&type=script&lang=js"
export * from "./DbsButton.vue?vue&type=script&lang=js"

import "./DbsButton.vue?vue&type=style&index=0&id=b31dc2aa&lang=scss"
script.render = render

export default script